import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customer-dash',
  templateUrl: './customer-dash.component.html',
  styleUrls: ['./customer-dash.component.scss']
})
export class CustomerDashComponent implements OnInit {

  constructor(
    private router: Router,
  ) {}
  ngOnInit() {
    this.requestTypeSelected = this.requestTypes[0];
  }

  isLoading = false;
  /* Handle Search */
  searchedFor(d){
    this.loader(640);
  }
  loader(time) {
    this.isLoading = true;
    setTimeout( ()=>{this.isLoading = false},time?time:56 );
  }


  tableData ={
    keys: [
      {name:"Customer Name", key:'custName'},
      {name:"Email", key:'custEmail'},
      {name:"Phone", key:'custPhone'},
      {name:"Policies", key:'policy'},
      {name:"Policy Commencement", key:'policyCommencement'},
    ],
    values: [
      {custName: 'Umang Desai', custEmail: 'umang007@gmail.com', custPhone: '9800998214', policy: ['P27009189'], policyCommencement: "19 Dec 2018",},
      {custName: 'Rahul Vohres', custEmail: 'rahul@rventures.com', custPhone: '9872700091', policy: ['P67090167','P67090563'], policyCommencement: "11 Mar 2020",},
      {custName: 'Nitin Kamat', custEmail: 'nitin@zerothe.com', custPhone: '9877682820', policy: ['P210901S3'], policyCommencement: "12 Apr 2019",},
      {custName: 'Seren Wade', custEmail: 'wsere@gmail.com', custPhone: '8009821112', policy: ['P00789056'], policyCommencement: "01 Jan 2019",},
    ],
  };



  /* Navigate to new Intimation */
  newSR(to) {
    if('cust'==to) {
      this.router.navigate(['/app/customer360/details'], { queryParams: { }, replaceUrl: false } );
    }
    else if('policy'==to) {
      this.router.navigate(['/app/customer360/details'], { queryParams: { }, replaceUrl: false } );
    }
    else if('details'==to){
      this.router.navigate(['/app/customer360/details'], { queryParams: { }, replaceUrl: false } );
    }
  }


  modNewServiceReq:boolean = false;

  /* Request Type (Step 2) */
  requestTypes = [
    { type: "Non-Financial", name: "Address Change", formType: 'address' },
    { type: "Non-Financial", name: "Email ID Change", formType: 'email' },
    { type: "Non-Financial", name: "Name Change", formType: 'name' },
    { type: "Financial", name: "Date of Birth change", formType: 'dob' },
    { type: "Financial", name: "PIN Code change", formType: 'pin'  },
  ];
  requestTypeSelected: any = this.requestTypes[0];


  /* STEPS / WIZARD */
  current = 0;
  index = 'First-content';
  pre(): void {
    this.current -= 1;
    this.changeContent();
  }
  next(): void {
    this.current += 1;
    this.changeContent();
  }
  done(): void {
    this.modNewServiceReq = false;
    // this.router.navigate(['/app/customer360/details'], { queryParams: { }, replaceUrl: false } );
  }
  changeContent(): void {
    switch (this.current) {
      case 0: {
        this.index = 'First-content';
        break;
      }
      case 1: {
        this.index = 'Second-content';
        break;
      }
      case 2: {
        this.index = 'third-content';
        break;
      }
      default: {
        this.index = 'error';
      }
    }
  }

}
